import React from 'react';
import axios from 'axios';
import { CompactPicker } from 'react-color';
import { CardContent, Popover } from '@mui/material';
import * as settings from "../../settings"

export default function CardColorPicker(props) {
    const plan = props.plan
    const [planColor, setPlanColor] = React.useState(props.color)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    function handleChangeComplete(c) {
        console.log(c)
        setPlanColor(c.hex)
        axios
        .put(`${settings.API_SERVER}/api/plan_detail/${plan}/`, { color: c.hex })
        .then((res) => {
            setAnchorEl(a => !a)
        })
        .catch((e) => console.log(e))
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <CardContent
            height="48px"
            sx={{ color: "none", background: planColor, "&:hover": { opacity: 0.8 }}}
            onClick={handleClick}
            >
            <Popover
                id={`${plan}-color-picker`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                sx={{ marginLeft: "24px", boxShadow: 1 }}
            >
                <CompactPicker
                    onChangeComplete={(e) => handleChangeComplete(e)}
                />
            </Popover>
        </CardContent>
    )
}
